'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeckoBtnsModel = exports.GeckoBtnModel = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GeckoBtnModel = exports.GeckoBtnModel = {
  name: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  class: _propTypes2.default.string,
  handler: _propTypes2.default.func,
  disabledWhen: _propTypes2.default.func,
  hideWhen: _propTypes2.default.func,
  size: _propTypes2.default.oneOf([_constants.GECKO_CONSTS.BTN_SIZE_LG, _constants.GECKO_CONSTS.BTN_SIZE_SM]),
  type: _propTypes2.default.oneOf([_constants.GECKO_CONSTS.BTN_TYPE_DANGER, _constants.GECKO_CONSTS.BTN_TYPE_DEFAULT, _constants.GECKO_CONSTS.BTN_TYPE_PRIMARY, _constants.GECKO_CONSTS.BTN_TYPE_INFO, _constants.GECKO_CONSTS.BTN_TYPE_SUCCESS, _constants.GECKO_CONSTS.BTN_TYPE_WARNING]),
  preset: _propTypes2.default.oneOf([_constants.GECKO_CONSTS.BTN_PRESET_ACTIONS, _constants.GECKO_CONSTS.BTN_PRESET_ACTIONS_COMPACT, _constants.GECKO_CONSTS.BTN_PRESET_ADD, _constants.GECKO_CONSTS.BTN_PRESET_CLONE, _constants.GECKO_CONSTS.BTN_PRESET_CLOSE, _constants.GECKO_CONSTS.BTN_PRESET_LOGIN, _constants.GECKO_CONSTS.BTN_PRESET_REMOVE, _constants.GECKO_CONSTS.BTN_PRESET_SAVE, _constants.GECKO_CONSTS.BTN_PRESET_SEND])
};

var GeckoBtnsModel = exports.GeckoBtnsModel = _propTypes2.default.arrayOf(_propTypes2.default.shape(GeckoBtnModel));